module.exports = __webpack_public_path__ + "img/flechasDireccionales.31babbeb.png";